package com.rosario.juridico.platform

/**
 * Implementación de JS para Analytics (Integración con gtag.js o similar).
 */
actual object AnalyticsLogger {
    actual fun logEvent(name: String, params: Map<String, Any?>) {
        try {
            // 1. Convertimos el mapa de Kotlin a un objeto JSON nativo de JS
            val jsParams = kotlin.js.json()
            params.forEach { (key, value) ->
                if (value != null) jsParams[key] = value
            }

            // 2. Invocación nativa al scope global del navegador (gtag.js)
            // Usamos interoperabilidad directa para asegurar que GA4 reciba los datos
            if (js("typeof gtag === 'function'")) {
                js("gtag('event', name, jsParams)")
            } else {
                println("GA4 Debug: gtag no definido. Evento $name descartado.")
            }
        } catch (e: Exception) {
            // Fallback silencioso para producción, log en debug
            println("Analytics Exception (JS): ${e.message}")
        }
    }
}
